module.exports = __webpack_public_path__ + "static/media/ico_sucess.90f60630.svg";